package com.kinoshazam.uiKit.components.cells.cellItem

import com.kinoshazam.uiKit.components.textLabel.TextLabelState


data class CellItemState(
    val title: TextLabelState,
    val value: TextLabelState? = null,
)
